import React from 'react';
import styles from './style.module.scss';
import VisaIcon from '../../../../../../../../assets/svg/icons/cards/VisaIcon';
import MastercardIcon from '../../../../../../../../assets/svg/icons/cards/MastercardIcon';
import DiscoverIcon from '../../../../../../../../assets/svg/icons/cards/DiscoverIcon';
import AmexIcon from '../../../../../../../../assets/svg/icons/cards/AmexIcon';

const DualPricing = ({ values, formatCurrency, formatPercentage }) => {

  const getPricingDataById = (id) => {
    let pricing = values.find((price) => price.id === id);
    return pricing ? pricing.pivot : { dollars: 0, percent: 0 };
  };

  return (
    <div className={styles.dualPricing}>
      <div className={styles.rateCard}>
        <div className={styles.ratesList}>
          <div className={styles.rateItem}>
            <span className={styles.rateLabel}>Preferred dual pricing rate</span>
            <span className={styles.rateValue}>{formatPercentage(getPricingDataById(35).percent)}</span>
          </div>
          <div className={styles.rateItem}>
            <span className={styles.rateLabel}>Monthly Fee</span>
            <span className={styles.rateValue}>{formatCurrency(getPricingDataById(17).dollars)}/mo</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DualPricing; 